import Pusher from 'pusher-js';
import { useToast } from 'vue-toastification';
import { useNotificationsStore } from '@/state/pinia/notifications';

let pusher = null;
let channel = null;
const toast = useToast();

export const FILE_MANAGER_EVENT = 'fileManagerUpdate';

export function handleFileManagerEvent(data) {
    window.dispatchEvent(new CustomEvent(FILE_MANAGER_EVENT, { detail: data }));
}

export function initializePusher(userUuid) {

    if (pusher) {
        disconnectPusher();
    }

    // No key in this build (e.g. stage) → no realtime, but never a throw:
    // this runs inside the SSO callback and would turn a successful login
    // into "Authentication failed".
    if (!process.env.VUE_APP_PUSHER_KEY) return;

    pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
        cluster: process.env.VUE_APP_PUSHER_CLUSTER,
        encrypted: true
    });

    channel = pusher.subscribe(`${userUuid}`);
    
    channel.bind('batch-action-status-changed', (data) => {

        if (data.status === "completed") {
            toast.success('Operacja zakończona sukcesem!');
        }

        handleFileManagerEvent(data);
    });

    channel.bind('notification-created', (data) => {
        try {
            useNotificationsStore().prepend(data);
        } catch { /* store not ready */ }
    });

    return channel;
}

export function disconnectPusher() {
    if (pusher) {
        pusher.disconnect();
        pusher = null;
        channel = null;
    }
}

export { channel, pusher };
